import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/products/radioguide/webp/reinvox-duo-dark.webp")